import React from 'react';
import About1 from '../../images/about/about-8.jpg';
import About2 from '../../images/about/about-9.jpg';
import About3 from '../../images/about/about-10.jpg';
import Shape from '../../images/about/shape13.png';
import Shape2 from '../../images/about/shape10.svg';
import Call from '../../images/about/call.svg';
import aut1 from '../../images/about/aut-1.jpg';
import aut2 from '../../images/about/aut-2.jpg';
import aut3 from '../../images/about/aut-3.jpg';
import dogsid from '../../images/about/dog-sid-img.png';

const AboutS2 = (props) => {



    return (
        <section className={"" + props.hclass}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 col-12">
                        <div className="about-image">
                            <div className="image1">
                                <img src={About1} alt="" />
                            </div>
                            <div className="image2">
                                <img src={About2} alt="" />
                                    <div className="shape">
                                    <img src={Shape} alt="" />
                                    </div>
                            </div>
                            <div className="image3">
                                <img src={About3} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-6 col-12">
                        <div className="right-content">
                            <h3>
                                Progettata per il Benessere, Costruita per la <span>Sicurezza</span>.
                            </h3>
                            <p>
                                Kleeo non è una semplice lettiera, ma un ecosistema di igiene avanzato.
                                Grazie al design Safe-Dome a corpo fisso, abbiamo eliminato il rischio di
                                schiacciamento tipico delle lettiere rotanti: la struttura esterna resta immobile mentre il
                                cuore tecnologico si occupa della pulizia.
                            </p>
                            <p>
                                Ogni componente è pensato per durare, con un motore industriale testato per oltre 2000 ore di lavoro.
                                La silenziosità è estrema (meno di 45dB), permettendo a te e al tuo gatto di convivere con Kleeo senza alcuno stress acustico.
                            </p>

                            <div className="author-wrap">
                                {/*<ul className="author-img">*/}
                                {/*    <li><img src={aut1} alt="" /></li>*/}
                                {/*    <li className="active"><img src={aut2} alt="" /></li>*/}
                                {/*    <li><img src={aut3} alt="" /></li>*/}
                                {/*</ul>*/}
                                {/*<div className="author-text">5m+ Customer <div className="shape"><img*/}
                                {/*    src={Shape2} alt="" /></div>*/}
                                {/*</div>*/}
                                <div className="contact">
                                    <div className="icon">
                                        <img src={Call} alt="phone" />
                                    </div>
                                    <div className="text">
                                        <span>Telefono:</span>
                                        <h4><a href="tel:+393487226077">+39 348 722 6077</a></h4>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            {/*<div className="dog-sidimg">*/}
            {/*    <img src={dogsid} alt="" />*/}
            {/*</div>*/}
        </section>
    )
}

export default AboutS2;